<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @before-open="beforeOpen"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="handleRowAdd"
        >
          新增
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { mapGetters } from 'vuex'
import { getList, add, update, remove, getDetail } from './api'
import { initDataTime, numSeparator } from '@/basic-common/util/common'
import { desensitizationDispose } from '@/basic-common/util/desensitization'

const phonePattern = /^1[3-9]\d{9}$/

export default {
  name: 'system-device-person-in-charge',
  mixins: [crudMixins],
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入电话'))
        return
      }
      if (!phonePattern.test(value)) {
        callback(new Error('请输入正确的手机号'))
        return
      }
      callback()
    }

    return {
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        searchMenuSpanSuper: 24,
        searchSize: 'small',
        menu: true,
        addBtn: false,
        editBtn: true,
        delBtn: true,
        viewBtn: true,
        dialogWidth: '560px',
        dialogClickModal: false,
        column: [
          {
            label: '负责人姓名',
            prop: 'name',
            search: true,
            searchPlaceholder: '请输入负责人姓名',
            searchSpan: 6,
            minWidth: 120,
            overHidden: true,
            rules: [
              { required: true, message: '请输入负责人姓名', trigger: 'blur' },
              { max: 50, message: '负责人姓名长度不能超过50个字符', trigger: 'blur' },
            ],
          },
          {
            label: '职责',
            prop: 'duty',
            search: true,
            searchPlaceholder: '请输入职责',
            searchSpan: 6,
            minWidth: 180,
            overHidden: true,
            rules: [
              { required: true, message: '请输入职责', trigger: 'blur' },
              { max: 100, message: '职责长度不能超过100个字符', trigger: 'blur' },
            ],
          },
          {
            label: '电话',
            prop: 'phone',
            search: true,
            searchPlaceholder: '请输入电话',
            searchSpan: 6,
            minWidth: 130,
            overHidden: true,
            rules: [{ validator: validatePhone, trigger: 'blur' }],
          },
          {
            label: '排序',
            prop: 'sort',
            type: 'number',
            value: 0,
            min: 0,
            precision: 0,
            minWidth: 90,
            span: 24,
            rules: [{ type: 'number', message: '排序必须为数字', trigger: 'blur' }],
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 150,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            minRows: 3,
            maxRows: 5,
            maxlength: 255,
            showWordLimit: true,
            span: 24,
            hide: true,
            rules: [{ max: 255, message: '备注长度不能超过255个字符', trigger: 'blur' }],
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.base_device_person_in_charge_add, false),
        viewBtn: this.vaildData(this.permission.base_device_person_in_charge_view, false),
        editBtn: this.vaildData(this.permission.base_device_person_in_charge_edit, false),
        delBtn: this.vaildData(this.permission.base_device_person_in_charge_delete, false),
      }
    },
  },
  methods: {
    onLoad(page, params = {}) {
      if (this.initstate) {
        this.initstate = false
        return
      }
      this.queryData = this.formatParams(Object.assign({}, this.defaultParams, params, this.query))
      if (!this.apiConfig || !this.apiConfig.getList) return
      this.loading = true
      const requestParams = {
        ...this.queryData,
        page: page.currentPage,
        size: page.pageSize,
      }
      this.apiConfig.getList(requestParams).then((res) => {
        this.responseData = res.data.data.records
        this.page.total = res.data.data.total
        this.responseData = initDataTime(this.responseData, this.option.column)
        this.data = numSeparator(this.responseData, this.option, 'list')
        this.data = desensitizationDispose(this.responseData, 'list', ['phone'])
        if (this.initCardData) {
          this.initCardData()
        } else {
          this.cardData = res.data.data
        }
        if (this.afterSearch) this.afterSearch()
      }).finally(() => {
        this.loading = false
        this.$nextTick(() => {
          if (this.option && !this.option.cancelHijack && this.$refs.crud) {
            this.$refs.crud.getTableHeight && this.$refs.crud.getTableHeight()
            this.$refs.crud.doLayout && this.$refs.crud.doLayout()
          }
        })
      })
    },
    handleRowAdd() {
      if (this.$refs.crud && this.$refs.crud.rowAdd) {
        this.$refs.crud.rowAdd()
      }
    },
    beforeOpen(done, type) {
      this.openType = type
      if (type === 'add') {
        this.form = {
          name: '',
          duty: '',
          phone: '',
          sort: 0,
          remark: '',
        }
        done()
        return
      }
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then((res) => {
          this.form = res.data.data || res.data
          done()
        })
        return
      }
      done()
    },
  },
}
</script>
